/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconArrowRight.vue?vue&type=template&id=5e867e82&scoped=true"
import script from "./IconArrowRight.vue?vue&type=script&lang=js"
export * from "./IconArrowRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e867e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e867e82')) {
      api.createRecord('5e867e82', component.options)
    } else {
      api.reload('5e867e82', component.options)
    }
    module.hot.accept("./IconArrowRight.vue?vue&type=template&id=5e867e82&scoped=true", function () {
      api.rerender('5e867e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconArrowRight.vue"
export default component.exports